class FacetFilters extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('.filters__form');
    this.bindEvents();
  }

  bindEvents() {
    this.form.addEventListener('change', this.onFilterChanged.bind(this));
  }

  onFilterChanged() {
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData);
    const url = new URL(window.location.href);

    // Clear existing filter params and pagination
    Array.from(url.searchParams.keys()).forEach(key => {
      if (key.startsWith('filter.') || key === 'page') {
        url.searchParams.delete(key);
      }
    });

    const hasActiveFilters = Array.from(searchParams.entries()).length > 0;
    if (hasActiveFilters) {
      for (let [key, value] of searchParams.entries()) {
        const input = this.form.querySelector(`[name="${key}"]`);
        const filterParam = input?.getAttribute('data-filter-param') || key;
        url.searchParams.append(`${filterParam}`, value);
      }
    }

    this.fetchAndUpdateContent(url);
  }

  async fetchAndUpdateContent(url) {
    try {
      const collectionGridElement = document.querySelector('.collection-grid');
      const sectionId = collectionGridElement?.getAttribute('section-id');
      
      const searchParams = url.search ? `${url.search}&section_id=${sectionId}` : `?section_id=${sectionId}`;
      const response = await fetch(`${window.location.pathname}${searchParams}`);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      
      // Update the collection grid
      const collectionGrid = html.getElementById('collection-grid');
      if (collectionGrid) {
        document.getElementById('collection-grid').innerHTML = collectionGrid.innerHTML;
      }

      // Update URL
      window.history.pushState({ path: url.toString() }, '', url.toString());

    } catch (error) {
      console.error('Error updating filters:', error);
    }
  }
}

if (!customElements.get('facet-filters')) {
  customElements.define('facet-filters', FacetFilters);
}